import $ from 'jquery';

// Dropdown filter
export default class MapListSwitch {

  constructor($element, options) {
    console.log($element);

    $element.find('button').on('click', this.onClick.bind(this));
  }

  onClick(ev) {
    $(ev.currentTarget).parent().find('button').addClass('disabled');
    $(ev.currentTarget).removeClass('disabled');
    let view = $(ev.currentTarget).data('set-view');
    $('[data-view]').hide();
    $('[data-view="' + view + '"]').show();

    let map = $('[data-view="' + view + '"]').find('#jobs-map').get(0);

    map && map.filter.update();
    map && map.filter.resize();
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/components/MapListSwitch.js
 **/